import React from 'react';

import { fadeIn, fadeOutThen } from '../helpers';
import { withRouter } from 'react-router-dom';

class Lightbox extends React.Component {
	constructor(props) {
		super(props);
		this.handleExit = this.handleExit.bind(this);
		this.escListener = this.escListener.bind(this);
	}

	escListener(e) {

		if (e.key === 'Escape' || e.keyCode === 27) {
			switch (this.props.type) {
				case 'bio':
					this.handleExit('/about/', e);
					break;
				default:
					this.handleExit('/', e);
					break;
			}
		}
	}

	componentDidMount() {
		fadeIn();
		document.addEventListener('keyup', this.escListener);
		document.querySelector('body').classList.add('js-noScroll');
	}

	componentDidUpdate(prevProps, prevState) {
		fadeIn();

		if(prevProps.activeBio !== this.props.activeBio) {
			this.setState({enabled: true});
		}
	}

	componentWillUnmount() {
		document.removeEventListener('keyup', this.escListener);
		document.querySelector('body').classList.remove('js-noScroll');
	}

	// lets us do a transition before leaving page
	handleExit(target, e) {
		e.preventDefault();

		document.removeEventListener('keyup', ()=>{return});

		fadeOutThen(document.querySelector(`.lightbox--contentInner__${this.props.type}`), function() {
			fadeOutThen(document.querySelector('.lightbox'), function() {
				this.props.history.push(target);
			}.bind(this));
		}.bind(this));
	}

	render() {

		if(this.props.type === 'bio') {
				return (
					<div className="lightbox js-fade__veryquick js-fadeMeIn">
						<div className="exit--container">
							<a className="exit" href="/about/" onClick={(e)=>{this.handleExit('/about/', e)}} /> 
						</div>
							<div className={`lightbox--contentInner lightbox--contentInner__${this.props.type} js-fade__quick js-fadeMeIn`}>
								<div className="lightbox--bio--info">
									<div className="lightbox--bio--nameAndSubtitle">
										<span className="name">{this.props.details.name}</span>
										{ this.props.details.subtitle &&
											<span className="about--bio--subtitle">{this.props.details.subtitle}</span>
										}
									</div>
									<img className="lightbox--bio--portrait" src={`/img/about-portrait-${this.props.details.url}.jpg`} srcSet={`/img/about-portrait-${this.props.details.url}.jpg 1x, /img/about-portrait-${this.props.details.url}@2x.jpg 2x`} alt={`portrait of ${this.props.details.name}`}/>
									{this.props.details.bio}
								</div>
							</div>
					</div>
				)
			} else {
			return (
				''
			)
		}
	}
}

export default withRouter(Lightbox);


/** WEBPACK FOOTER **
 ** ./src/components/LightBox.js
 **/